import { AddressInfo } from './address-info';
import { LegalEntityType } from '../../marketplace/timeline/models/enums/legal-enity-type';
import { getEmptyGuid } from '../../../utils/typedHelper';

export interface SellerDocsInfo {
    id: string;
    fullLegalEntityName: string;
    legalEntityType: LegalEntityType;
    legalEntityRegistrationState: string;
    legalEntityAddress: AddressInfo;
    recipientFullName: string;
    recipientTitle: string;
    recipientAddressInfo: AddressInfo;
}

export const createEmptySellerDocsInfo = (): SellerDocsInfo => ({
    id: getEmptyGuid(),
    fullLegalEntityName: '',
    legalEntityType: LegalEntityType.SoleProprietorships,
    legalEntityRegistrationState: '',
    legalEntityAddress: {
        id: getEmptyGuid(),
        streetAddress: '',
        city: '',
        state: '',
        zipCode: '',
    },
    recipientFullName: '',
    recipientTitle: '',
    recipientAddressInfo: {
        id: getEmptyGuid(),
        streetAddress: '',
        city: '',
        state: '',
        zipCode: '',
    },
});
